import { Component } from '@angular/core';


@Component({
	selector: 'devo-donors-tab-2-part',
	standalone: true,
	templateUrl: './devo-donors-tab-2.part.html',
	styleUrls: [`./devo-donors-tab-2.part.scss`],
})
export class DevoDonorsTab2Part {
}
